import * as actions from "./department.actions";
import { ActionType, createReducer } from "typesafe-actions";
import { DepartmentReducerType } from "./types";

export type DepartmentActions = ActionType<typeof actions>;

export const initialState: DepartmentReducerType = {
  isLoading: false,
  errorMessage: "",
  listDepartment: [],
};

export const DepartmentReducer = createReducer<
DepartmentReducerType,
  DepartmentActions
>(initialState)
  .handleAction(actions.getDepartmentAsync.request, (state) => ({
    ...state,
    isLoading: true,
    errorMessage: '',
    redirectQueue: ''
  }))
  .handleAction(actions.getDepartmentAsync.success, (state, action) => ({
    ...state,
    errorMessage: '',
    isLoading: false,
    listDepartment: action.payload.data.items,
  }))
  .handleAction(actions.getDepartmentAsync.failure, (state, action) => ({
    ...state,
    errorMessage: action.payload.message,
    isLoading: false,
  }))
